import { render, staticRenderFns } from "./ServiceCarousel.vue?vue&type=template&id=7f11bf93"
import script from "./ServiceCarousel.vue?vue&type=script&lang=js"
export * from "./ServiceCarousel.vue?vue&type=script&lang=js"
import style0 from "@/css/service-carousel/service-carousel.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports